import React from 'react'
import Footer from '../Footer';
import Header from '../Header';
import Servicedata from '../Api/service';

function Incometaxservicesservice() {

  

  return (
    <>
      <Header/>

      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <h1 className="text-white">Income Tax Services</h1>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-light rounded-pill"
              >
                SERVICES
              </button>
            </div>
            <h1 style={{ textAlign: 'center' }}>
              <span>Income tax return</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <section id="about" className="about section light-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={100}>
              <img src="assets\images\svg\text.jpeg" alt className="h-100 p-2 img-fluid" />
            </div>
            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay={200}>
              <div className="about-content ps-0 ps-lg-3">
                {/* <h3>"Innovation is not just our Strength; it is our Foundation."</h3> */}
                <p className="fst-italic">
                  <b>Sai Financial Service</b>Provider acts as a facilitator for ITR filing and does not guarantee refunds, exemptions, or other outcomes. The final assessment lies with the Income Tax Department.
                </p>
                <h3>Services terms&conditions:</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Document Verification and Preparation:</b> Guidance in organizing and verifying documents such as Form 16, investment proofs, bank statements, and other financial records. </p></li>
                  <li><p className="fst-italic"><b>Service Fee Policy:</b> The ₹2,500 service charge is non-refundable, even if the filing is delayed or rejected due to inaccuracies in the information provided by the client..</p></li>
                  <li><p className="fst-italic"><b>Government Fees and Penalties</b> Any government-mandated fees, penalties for late filing, or taxes due must be borne by the client and are not covered in the service charge.</p></li>
                  <li><p className="fst-italic"><b>Accuracy of Information:
                  </b> Clients are responsible for providing accurate and complete financial details and supporting documents. Sai Financial Service Provider will not be liable for penalties, interest, or issues arising from incorrect or incomplete information.</p></li>
                  <li><p className="fst-italic"><b>Processing Time:</b>Filing timelines depend on the accuracy and completeness of documents provided. Sai Financial Service Provider is not liable for delays caused by the Income Tax Department’s processing times.
                  </p></li>

                  {/* <li><p className="fst-italic"><b>Vehicle Loans:</b>This service is available for all major credit card networks, including Visa, MasterCard, and RuPay.</p></li>
                                    <li><p className="fst-italic"><b>Loan Against Property:</b>  Unlock the potential of your property to get funds for your business or personal needs.</p></li>
                                    <li><p className="fst-italic"><b>Others Loan:</b> We also provide other loan services like education loans, gold loans, agricultural loans and other loans designed to meet specific financial requirements.</p></li> */}
                </ol>
                <h3>Why Choose Us?</h3>
                <ol style={{ listStyle: 'disc' }}>
                  <li><p className="fst-italic"><b>Wide Network of Lenders:</b> We have partnerships with all major banks and financial institutions, allowing us to find the right loan offer for you.</p></li>
                  <li><p className="fst-italic"><b>Expert Guidance:</b> Our team of loan experts helps you throughout the loan process, from application to disbursement.</p></li>
                  <li><p className="fst-italic"><b>Customized Solutions:</b> Based on your needs and financial situation, we offer tailored loan solutions with competitive interest rates.</p></li>
                </ol>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="container section-title" data-aos="fade-up">

            <h1 style={{ textAlign: 'center' }}>
              <span>Income text  return</span> <span className="link-primary">Service</span>
            </h1>
          </div>
        </div>
      </section>
      <Servicedata/>
      <Footer />
    </>
  )
}

export default Incometaxservicesservice
